import { fetchInvitation, registerInvitation } from "@/data/invitations";
import { buildRegisterInvitation } from "@/views/Invitations/Register";

export const AdminInvitationsAccept = buildRegisterInvitation(
  fetchInvitation,
  registerInvitation,
  "SESSION_INVITATION.ACCEPTED_MANAGER_TEXT",
);
